import { render, staticRenderFns } from "./OrdersTableRow.vue?vue&type=template&id=5ebf2aab&scoped=true&"
import script from "./OrdersTableRow.vue?vue&type=script&lang=js&"
export * from "./OrdersTableRow.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableRow.vue?vue&type=style&index=0&id=5ebf2aab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf2aab",
  null
  
)

export default component.exports